import * as toolbox from '../components/common/toolbox';
import * as types from './action-types';
import firebase from 'firebase/compat/app';
import { collection, getCountFromServer, getFirestore, query, where, deleteField } from 'firebase/firestore';
import _ from 'lodash';

const firestore = firebase.firestore();

/*-----------------------------------------------*/
/*  USERS
/*-----------------------------------------------*/

export function subUser(handle, email, callback) {

	return dispatch => {

		dispatch({ type: types.USER + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/users/users').doc(email).onSnapshot((doc) => {
			var user = { ...doc.data(), id: doc.id };

			dispatch({ type: types.USER + '_FULFILLED', data: { ...user, email }, unsubscribe });
			if (typeof callback === 'function') callback(user);
		});
	};
}
export function updateUser(handle, email, profileId, user, callback) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		var batch = firestore.batch();

		const userRef = firestore.collection(handle + '/users/users');
		const profileRef = firestore.collection(handle + '/profiles/profiles');

		if (email) batch.set(userRef.doc(email), { ...user }, { merge: true });
		if (profileId) batch.set(profileRef.doc(profileId), { roles: user.roles, modified: new Date() }, { merge: true });

		batch.commit().then(() => {
			window.toastr.success('The User record has been successfully saved/updated', 'User Saved!');
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
			if (typeof callback === 'function') callback(email);
		}).catch((error) => {
			toolbox.process_error(error, 'User NOT Saved!');
		});
	};
}
export function deleteUser(handle, email, callback) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		firestore.collection(handle + '/users/users').doc(email).delete()
			.then(() => {
				window.toastr.success('The User record has been permanently deleted', 'User Saved!');
				dispatch({ type: types.USER + '_SAVE_FULFILLED' });
				if (typeof callback === 'function') callback(email);
			}).catch((error) => {
				toolbox.process_error(error, 'User NOT Saved!');
			});
	};
}
export function subUserLocations(handle, email, callback) {

	return dispatch => {

		dispatch({ type: types.USER_LOCATIONS + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/users/users/' + email + '/locations').get().then((querySnapshot) => {

			var locations = [];
			querySnapshot.forEach((doc) => {
				locations.push({ ...doc.data(), id: doc.id });
			});

			dispatch({ type: types.USER_LOCATIONS + '_FULFILLED', data: locations, unsubscribe });
			if (typeof callback === 'function') callback();
		});
	};
}

/*-----------------------------------------------*/
/*  ACTIVITY LOG
/*-----------------------------------------------*/

// export function subActivityLog(handle, userId, limit, mostRecent) {

// 	return async dispatch => {

// 		dispatch({ type: types.ACTIVITY_LOG + '_PENDING' });

// 		const logRef = (mostRecent) ? firestore.collection(handle + '/users/users/' + userId + '/activity-log').where('mostRecent', '==', true).orderBy('date', 'desc') : firestore.collection(handle + '/users/users/' + userId + '/activity-log').orderBy('date', 'desc');
// 		logRef.limit(limit).get().then(async (querySnapshot) => {
// 			var entries = [];
// 			querySnapshot.forEach((doc) => {
// 				entries.push({ ...doc.data() });
// 			});
// 			var activity_log = _.orderBy(entries, ['date'], ['desc']);

// 			const db = getFirestore();
// 			const coll = collection(db, handle + '/users/users/' + userId + '/activity-log');
// 			const query_ = query(coll);

// 			const snapshot = await getCountFromServer(query_);
// 			const count = snapshot.data().count;

// 			dispatch({ type: types.ACTIVITY_LOG + '_FULFILLED', data: { data: activity_log, totalCount: count }, unsubscribe: null });
// 		});
// 	};
// }

export function subActivityLog(handle, userId, limit, mostRecent, source, filterId, lowTypeCode, highTypeCode) {

	return async dispatch => {

		dispatch({ type: types.ACTIVITY_LOG + '_PENDING' });

		const thirtyDaysAgo = new Date();
		thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

		const logRef = (mostRecent)
			? firestore.collection(handle + '/activity-log/activity-log').where('mostRecent', '==', true).where('date', '>=', thirtyDaysAgo).orderBy('date', 'desc')
			: (source)
				? (source == 'employees')
					? firestore.collection(handle + '/activity-log/activity-log').where('userId', '==', userId).orderBy('date', 'desc').limit(limit)
					: firestore.collection(handle + '/activity-log/activity-log').where('id', '==', filterId).where('type', '>=', lowTypeCode).where('type', '<=', highTypeCode).orderBy('type', 'desc').orderBy('date', 'desc').limit(limit)
				: firestore.collection(handle + '/activity-log/activity-log').orderBy('date', 'desc').limit(limit);

		var unsubscribe = logRef.onSnapshot(async (querySnapshot) => {
			var entries = [];
			querySnapshot.forEach((doc) => {
				entries.push({ ...doc.data() });
			});
			var activity_log = _.orderBy(entries, ['date'], ['desc']);

			const db = getFirestore();
			const coll = collection(db, handle + '/activity-log/activity-log');
			// const query_ = query(coll, where('id', '==', filterId));
			const query_ = (mostRecent)
				? query(coll, where('mostRecent', '==', true))
				: (source)
					? (source == 'employees')
						? query(coll, where('userId', '==', userId))
						: query(coll, where('id', '==', filterId), where('type', '>=', lowTypeCode), where('type', '<=', highTypeCode))
					: query(coll);

			const snapshot = await getCountFromServer(query_);
			const count = snapshot.data().count;

			dispatch({ type: types.ACTIVITY_LOG + '_FULFILLED', data: { data: activity_log, totalCount: count }, unsubscribe: unsubscribe });
		});
	};
}
export function subMostRecent(handle, userId, limit) {

	return async dispatch => {

		// dispatch({ type: types.ACTIVITY_LOG + '_PENDING' });

		// firestore.collection(handle + '/users/users/' + userId + '/activity-log').where('type', 'in', ['0', '1']).limit(limit).get().then(async (querySnapshot) => {
		// 	var entries = [];
		// 	querySnapshot.forEach((doc) => {
		// 		entries.push({ ...doc.data(), id: doc.id });
		// 	});
		// 	var most_recent = _.orderBy(entries, ['date'], ['desc']);

		// 	const db = getFirestore();
		// 	const coll = collection(db, handle + '/users/users/' + userId + '/activity-log');
		// 	const query_ = query(coll, where('type', 'in', ['0', '1']));

		// 	const snapshot = await getCountFromServer(query_);
		// 	const count = snapshot.data().count;

		// 	dispatch({ type: types.ACTIVITY_LOG + '_FULFILLED', data: { data: most_recent, totalCount: count }, unsubscribe: null });
		// });
	};
}

/*-----------------------------------------------*/
/*  SERVICE ITEMS
/*-----------------------------------------------*/

export function addItemToRecent(handle, item, userId) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		firestore.collection(handle + '/users/users/' + userId + '/items').doc('items').set({ recent: { [item.id]: new Date() } }, { merge: true }).then(() => {
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
		}).catch((error) => {
			toolbox.process_error(error, 'Unable to add item to recents!');
		});
	};
}
export function trimRecent(handle, recentArray, typeId, userId) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		var batch = firestore.batch();
		var deleteValues = recentArray.slice(100);
		deleteValues.forEach((value) => {
			batch.set(firestore.collection(handle + '/users/users/' + userId + '/service-items').doc(typeId.toString()), { recent: { [value.id]: deleteField() } }, { merge: true });
		});

		batch.commit().then(() => {
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
		}).catch((error) => {
			toolbox.process_error(error, 'Unable to add item to recents!');
		});
	};
}
export function subUserRecentItems(handle, email) {

	return dispatch => {

		dispatch({ type: types.USER_RECENT_ITEMS + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/users/users/' + email + '/items').onSnapshot((querySnapshot) => {

			var recentItems = {};
			querySnapshot.forEach((doc) => {
				recentItems[doc.id] = doc.data();
			});

			dispatch({ type: types.USER_RECENT_ITEMS + '_FULFILLED', data: recentItems, unsubscribe });
		});
	};
}